import ReactHtmlParser from 'react-html-parser'
import { Button } from 'reactstrap'
import Link from 'next/link'
import GuruModal from './GuruModal'
import useTranslation from '../hooks/UseTranslation'

const PremiumModal = (props) => {
  const { t } = useTranslation()
  const btn = (
    <div className='text-right'>
      <Link href='/get-started#features'>
        <Button color='primary'>{t('know_more')}</Button>
      </Link>
    </div>
  )
  return (
    <GuruModal title={t('premium_modal_title')} button={btn} {...props}>
      {ReactHtmlParser(t('premium_modal_content'))}
    </GuruModal>
  )
}

export default PremiumModal
